module.exports = __webpack_public_path__ + "static/media/github.1168bf69.svg";